import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function FinalClose() {
  return <section className="py-24 px-6 bg-brown-dark text-center relative overflow-hidden" data-id="element-60">
      {/* Background image overlay effect */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://cdn.magicpatterns.com/uploads/9a4vhTTwWmMtZeLT9KHqqv/heylloyd-image-1776220135630.png')] bg-cover bg-center mix-blend-overlay" data-id="element-61"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-brown-dark via-brown-dark/90 to-brown-dark/80" data-id="element-62"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-63">
        <FadeIn data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-light mb-10 font-serif" data-id="element-65">
            Una Última Cosa...
          </h2>

          <p className="text-xl md:text-2xl text-cream leading-relaxed mb-12 font-serif italic" data-id="element-66">
            "Piense en cómo se sentirá la próxima vez que sus nietos lleguen de
            visita y usted pueda levantarse del sofá sin ayuda, caminar hasta la
            cocina sin ese dolor familiar y servirles la cena que tanto les
            gusta."
          </p>

          <p className="text-2xl md:text-3xl font-bold text-white mb-12" data-id="element-67">
            Ese momento vale más que $6.39.
          </p>

          <Button href="#comprar" className="w-full sm:w-auto text-xl px-12 py-6 bg-amber hover:bg-amber-light text-brown-dark shadow-amber/20" data-id="element-68">
            Quiero mi copia ahora
          </Button>
        </FadeIn>
      </div>
    </section>;
}